import { Modal, Button } from "react-bootstrap";

const SerialNumberModal = ({ show, onHide, onConfirm }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Create New Serial Number</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This action will create a new serial number for the tower.</p>
        <p>
          When creating a new serial number, please ensure you have the correct
          state (which should be pulled from Zoho), tower type, and tower
          subtype.
        </p>
        <p>
          After entering this information, a serial number will be generated and
          displayed in the serial number field, this will be used to identify
          the tower in the system.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Create New Serial Number
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SerialNumberModal;
